module.exports = __webpack_public_path__ + "img/r2.c4093ad8.jpg";